module.exports = {
  ENROLL: 2,
  ACTIVE: 3,
  INACTIVE: 4,
  SOON: 5
};